export default function(_form) {

  const requiredFields = _form.querySelectorAll('[required]');

  // Remove the required attributes on all fields so that we can manage this ourselves.
  [...requiredFields].forEach(field => field.removeAttribute('required'));

  // Listen for form submit.
  _form.addEventListener('submit', e => {

    let hasRequiredError = false;
    
    // Loop through all required fields, setting error messages as we go.
    [...requiredFields].forEach(field => {
      
      const parent = field.closest('.form__field');
      
      // This may be a subsequent submit? - if so remove previous errors if they exist.
      parent.querySelector('.form__error')?.remove();
      
      // Show field required error if empty.
      if (!field.value) {
        parent.insertAdjacentHTML("beforeend", `<div class="form__error">Please fill in this field</div>`);
        hasRequiredError = true;
      }
    });

    // Prevent form submit if an error occurred.
    if (hasRequiredError) {
      e.preventDefault();
    }
  });

}